import { I18n } from "@shared/modules/utils/LangUtil";

export const REGEXP_PREFIX = "regex_";

export const ADD_BENE_STEPS = {
    CHANNEL_DETAILS: {
        name: "CHANNEL_DETAILS",
        label: I18n("g.lbl.countrychannel"),
        step: 1
    },
    PERSONAL_DETAILS: {
        name: "PERSONAL_DETAILS",
        label: I18n("g.lbl.benedet"),
        step: 2
    },
    CONTACT_DETAILS: {
        name: "CONTACT_DETAILS",
        label: I18n("g.lbl.benedet"),
        step: 3
    },
    DYNAMIC_FIELDS: {
        name: "DYNAMIC_FIELDS",
        label: I18n("g.lbl.benedet"),
        step: 4
    }
};

export const DEFAULT_STEP = ADD_BENE_STEPS.CHANNEL_DETAILS;

export const cashServiceId = 1;
export const bankingServiceId = 2;
export const visaServiceId = 4;
export const walletServiceId = 5;

export const prepare = configs => {
    if (Array.isArray(configs)) {
        configs.map(conf => {
            conf.validationProfiles = [];
            if (conf.field.required === true || conf.field.required === "Y") conf.validationProfiles.push("default");
            if (conf.field.defaultValue) conf.initVal = conf.field.defaultValue;
            if (conf.field.validationRegex.length !== 0) {
                conf.field.validationRegex.map(regex => {
                    conf.validationProfiles.push(`${REGEXP_PREFIX}${regex.value}`);
                });
            }
            if (conf.field.minLength || conf.field.maxLength)
                conf.sizeRange = [conf.field.minLength || 0, conf.field.maxLength || Infinity];
            conf.required = conf.field.required;
            conf.type = conf.field.type;
            conf.label = conf.field.label || conf.label;
        });
    } else {
        console.error("Only arrays allowed.");
    }
};

export const addBeneFieldConfigFunc = () => {
    return {
        country: {
            entityName: "BENEFICIARY",
            field: {
                defaultValue: null,
                minLength: null,
                maxLength: null,
                name: "country",
                label: I18n("g.lbl.remitcountry"), //"Country",
                required: true,
                type: "select",
                validationRegex: []
            }
        },
        channel: {
            entityName: "BENEFICIARY",
            field: {
                defaultValue: null,
                minLength: null,
                maxLength: null,
                name: "channel",
                label: I18n("g.lbl.channel"), //"Channel",
                required: true,
                type: "radio",
                validationRegex: []
            }
        },
        currency: {
            entityName: "BENEFICIARY",
            field: {
                defaultValue: null,
                minLength: null,
                maxLength: null,
                name: "currency",
                label: I18n("g.lbl.remitcurrency"), //"Currency",
                required: true,
                type: "select",
                validationRegex: []
            }
        },
        bank: {
            entityName: "BENEFICIARY",
            field: {
                defaultValue: null,
                minLength: null,
                maxLength: null,
                name: "bank",
                label: I18n("g.lbl.chbank"), //"Bank",
                required: true,
                type: "select",
                validationRegex: []
            }
        },
        branch: {
            entityName: "BENEFICIARY",
            field: {
                defaultValue: null,
                minLength: null,
                maxLength: null,
                name: "branch",
                label: I18n("g.lbl.branch"), //"Branch",
                required: true,
                type: "select",
                validationRegex: []
            }
        },
        ifsc: {
            entityName: "BENEFICIARY",
            field: {
                defaultValue: null,
                minLength: null,
                maxLength: null,
                name: "ifsc",
                label: I18n("g.lbl.branchifsc"), //"IFSC Code",
                required: true,
                type: "select",
                validationRegex: []
            }
        },
        swift: {
            entityName: "BENEFICIARY",
            field: {
                defaultValue: null,
                minLength: null,
                maxLength: null,
                name: "swift",
                label: I18n("g.lbl.swift"), //"SWIFT Code",
                required: true,
                type: "select",
                validationRegex: []
            }
        },
        routingNumber: {
            entityName: "BENEFICIARY",
            field: {
                defaultValue: null,
                minLength: null,
                maxLength: null,
                name: "routingNumber",
                label: I18n("g.msg.routingNumber"),
                required: true,
                type: "text",
                validationRegex: []
            }
        },
        accountNo: {
            entityName: "BENEFICIARY",
            field: {
                defaultValue: null,
                minLength: null,
                maxLength: null,
                name: "accountNo",
                label: I18n("g.lbl.accountno"), //"Account No.",
                type: "custom-pwd",
                validationRegex: []
            }
        },
        reAccountNo: {
            entityName: "BENEFICIARY",
            field: {
                defaultValue: null,
                minLength: null,
                maxLength: null,
                name: "reAccountNo",
                label: I18n("g.lbl.reaccountno"), //"Re-Type Account No.",
                type: "text",
                validationRegex: []
            }
        },
        acType: {
            entityName: "BENEFICIARY",
            field: {
                defaultValue: null,
                minLength: null,
                maxLength: null,
                name: "acType",
                label: I18n("g.lbl.actype"), //"Account Type",
                required: true,
                type: "select",
                validationRegex: []
            }
        },
        iban: {
            entityName: "BENEFICIARY",
            field: {
                defaultValue: null,
                minLength: null,
                maxLength: null,
                name: "iban",
                label: I18n("g.lbl.ibno"), //"Account Type",
                required: true,
                type: "text",
                validationRegex: []
            }
        },
        serviceProvider: {
            entityName: "BENEFICIARY",
            field: {
                defaultValue: null,
                minLength: null,
                maxLength: null,
                name: "serviceProvider",
                label: I18n("g.lbl.serviceprovider"), //"Service Provider",
                required: true,
                type: "select",
                validationRegex: []
            }
        },
        agentMaster: {
            entityName: "BENEFICIARY",
            field: {
                defaultValue: null,
                minLength: null,
                maxLength: null,
                name: "agentMaster",
                label: I18n("g.lbl.agentmaster"), //"Agent",
                required: true,
                type: "select",
                validationRegex: []
            }
        },
        agentBranch: {
            entityName: "BENEFICIARY",
            field: {
                defaultValue: null,
                minLength: null,
                maxLength: null,
                name: "agentBranch",
                label: I18n("g.lbl.agentbranch"), //"Agent Branch",
                required: true,
                type: "select",
                validationRegex: []
            }
        },
        beneficiaryType: {
            entityName: "BENEFICIARY",
            field: {
                defaultValue: null,
                minLength: null,
                maxLength: null,
                name: "beneficiaryType",
                label: I18n("g.lbl.beneficiarytype"), //"Beneficiary Type",
                required: true,
                type: "radio",
                validationRegex: []
            }
        },
        BENE_INSTITUTION_NAME: {
            entityName: "BENEFICIARY",
            field: {
                defaultValue: null,
                minLength: 1,
                maxLength: 100,
                name: "firstNameEn",
                label: I18n("g.lbl.instname"), //"instname",
                required: true,
                type: "text",
                validationRegex: []
            }
        },
        BENE_INSTITUTION_NAME_LOCAL: {
            entityName: "BENEFICIARY",
            field: {
                defaultValue: null,
                minLength: null,
                maxLength: null,
                name: "firstNameAr",
                label: I18n("g.lbl.instnamelocal"), //"linstnamelocal",
                required: true,
                type: "text",
                validationRegex: [],
                virtualKeyboardLang: "ar",
                dir: "rtl"
            }
        },
        BENE_INSTITUTION_CATEGORY: {
            entityName: "BENEFICIARY",
            field: {
                defaultValue: null,
                minLength: null,
                maxLength: null,
                name: "nationality",
                label: I18n("g.lbl.instcat"), //"Institution Category",
                required: true,
                type: "select",
                validationRegex: []
            }
        },
        BENE_FIRST_NAME: {
            entityName: "BENEFICIARY",
            field: {
                dtoPath: "firstName",
                defaultValue: null,
                minLength: 1,
                maxLength: 100,
                name: "firstNameEn",
                label: I18n("g.lbl.nameen1"), //"First Name",
                required: true,
                type: "text",
                validationRegex: [],
                sequence: 1
            }
        },
        BENE_FIRST_NAME_LOCAL: {
            entityName: "BENEFICIARY",
            field: {
                dtoPath: "localFirstName",
                defaultValue: null,
                minLength: null,
                maxLength: null,
                name: "firstNameAr",
                label: I18n("g.lbl.namear1"), //"local first name",
                required: true,
                type: "text",
                validationRegex: [],
                sequence: 2,
                virtualKeyboardLang: "ar",
                dir: "rtl"
            }
        },
        BENE_SECOND_NAME: {
            entityName: "BENEFICIARY",
            field: {
                dtoPath: "secondName",
                defaultValue: null,
                minLength: null,
                maxLength: null,
                name: "secondNameEn",
                label: I18n("g.lbl.nameen2"), //"Second Name",
                required: true,
                type: "text",
                validationRegex: [],
                sequence: 3
            }
        },
        BENE_SECOND_NAME_LOCAL: {
            entityName: "BENEFICIARY",
            field: {
                dtoPath: "localSecondName",
                defaultValue: null,
                minLength: null,
                maxLength: null,
                name: "secondNameAr",
                label: I18n("g.lbl.namear2"), //"local second name",
                required: true,
                type: "text",
                validationRegex: [],
                sequence: 4,
                virtualKeyboardLang: "ar",
                dir: "rtl"
            }
        },
        BENE_THIRD_NAME: {
            entityName: "BENEFICIARY",
            field: {
                dtoPath: "thirdName",
                defaultValue: null,
                minLength: null,
                maxLength: null,
                name: "thirdNameEn",
                label: I18n("g.lbl.nameen3"), //"Third Name",
                required: true,
                type: "text",
                validationRegex: [],
                sequence: 5
            }
        },
        BENE_THIRD_NAME_LOCAL: {
            entityName: "BENEFICIARY",
            field: {
                dtoPath: "localThirdName",
                defaultValue: null,
                minLength: null,
                maxLength: null,
                name: "thirdNameAr",
                label: I18n("g.lbl.namear3"), //"local third name",
                required: true,
                type: "text",
                validationRegex: [],
                sequence: 6,
                virtualKeyboardLang: "ar",
                dir: "rtl"
            }
        },
        BENE_FOURTH_NAME: {
            entityName: "BENEFICIARY",
            field: {
                dtoPath: "fourthName",
                defaultValue: null,
                minLength: null,
                maxLength: null,
                name: "fourthNameEn",
                label: I18n("g.lbl.nameen4"), //"Fourth Name",
                required: true,
                type: "text",
                validationRegex: [],
                sequence: 7
            }
        },
        BENE_FOURTH_NAME_LOCAL: {
            entityName: "BENEFICIARY",
            field: {
                dtoPath: "localFourthName",
                defaultValue: null,
                minLength: null,
                maxLength: null,
                name: "fourthNameAr",
                label: I18n("g.lbl.namear4"), //"local fourth name",
                required: true,
                type: "text",
                validationRegex: [],
                sequence: 8,
                virtualKeyboardLang: "ar",
                dir: "rtl"
            }
        },
        BENE_FIFTH_NAME: {
            entityName: "BENEFICIARY",
            field: {
                dtoPath: "fifthName",
                defaultValue: null,
                minLength: null,
                maxLength: null,
                name: "fifthNameEn",
                label: I18n("g.lbl.nameen5"), //"Fifth Name",
                required: false,
                type: "text",
                validationRegex: [],
                sequence: 9
            }
        },
        BENE_FIFTH_NAME_LOCAL: {
            entityName: "BENEFICIARY",
            field: {
                dtoPath: "localFifthName",
                defaultValue: null,
                minLength: null,
                maxLength: null,
                name: "fifthNameAr",
                label: I18n("g.lbl.namear5"), //"local fifth name",
                required: false,
                type: "text",
                validationRegex: [],
                sequence: 10,
                virtualKeyboardLang: "ar",
                dir: "rtl"
            }
        },
        lastNameEn: {
            entityName: "BENEFICIARY",
            field: {
                defaultValue: null,
                minLength: 1,
                maxLength: 100,
                name: "lastNameEn",
                label: I18n("g.lbl.lnameen"), //"Last Name",
                required: true,
                type: "text",
                validationRegex: []
            }
        },
        relationship: {
            entityName: "BENEFICIARY",
            field: {
                defaultValue: null,
                minLength: null,
                maxLength: null,
                name: "relationship",
                label: I18n("g.lbl.relationship"), //"Relationship",
                required: true,
                type: "select",
                validationRegex: []
            }
        },
        nationality: {
            entityName: "BENEFICIARY",
            field: {
                defaultValue: null,
                minLength: null,
                maxLength: null,
                name: "nationality",
                label: I18n("g.lbl.nationality"), //"Nationality",
                required: true,
                type: "select",
                validationRegex: []
            }
        },
        mobileCode: {
            entityName: "BENEFICIARY",
            field: {
                defaultValue: null,
                minLength: null,
                maxLength: null,
                name: "mobileCode",
                label: I18n("g.lbl.mobcode"), //"Mobile Number",
                required: true,
                type: "select",
                validationRegex: []
            }
        },
        mobileNumber: {
            entityName: "BENEFICIARY",
            // hideLabel: true,
            field: {
                defaultValue: null,
                minLength: null,
                maxLength: null,
                name: "mobileNumber",
                label: I18n("g.lbl.mobnumber"), //"Mobile Number",
                required: true,
                type: "number",
                validationRegex: []
            }
        },
        state: {
            entityName: "BENEFICIARY",
            field: {
                defaultValue: null,
                minLength: null,
                maxLength: null,
                name: "state",
                label: I18n("g.lbl.state"), //"State",
                required: true,
                type: "select",
                validationRegex: []
            }
        },
        district: {
            entityName: "BENEFICIARY",
            field: {
                defaultValue: null,
                minLength: null,
                maxLength: null,
                name: "district",
                label: I18n("g.lbl.district"), //"District",
                required: true,
                type: "select",
                validationRegex: []
            }
        },
        town: {
            entityName: "BENEFICIARY",
            field: {
                defaultValue: null,
                minLength: null,
                maxLength: null,
                name: "town",
                label: I18n("g.lbl.town"), //"Town",
                required: true,
                type: "select",
                validationRegex: []
            }
        },
        city: {
            entityName: "BENEFICIARY",
            field: {
                defaultValue: null,
                minLength: null,
                maxLength: null,
                name: "city",
                label: I18n("g.lbl.city"), //"District",
                required: true,
                type: "select",
                validationRegex: []
            }
        }
    };
};
